var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-dialog',{attrs:{"persistent":_setup.props.persistent,"fullscreen":_setup.props.fullscreen,"max-width":_setup.props.maxWidth,"transition":_setup.props.transition},model:{value:(_setup.aberto),callback:function ($$v) {_setup.aberto=$$v},expression:"aberto"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }